import {
  grey150,
  grey300,
  grey400,
  purple200,
  text_colorTextPrimary,
  text_colorTextSecondary,
  white100,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { button_transitionSpeed } from 'ext-ui/style/transitionSpeeds'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.ExpensePolicyChatEmptyState {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${spacing(8)} 0;
    text-align: center;

    & .icon {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background-color: ${purple200};
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: ${spacing(4)};

      svg {
        width: 32px;
        height: 32px;
      }
    }

    & .empty-state-title {
      ${font_lg};
      font-family: ${font_family_weight_medium};
      color: ${text_colorTextPrimary};
      margin-bottom: ${spacing(2)};
    }

    & .empty-state-subtitle {
      ${font_md};
      color: ${text_colorTextSecondary};
      margin-bottom: ${spacing(12)};
      max-width: 400px;
    }

    .prompts-list {
      display: flex;
      flex-direction: column;
      gap: ${spacing(2)};
      width: 100%;
      max-width: 500px;

      & .prompt-button {
        display: flex;
        align-items: center;
        gap: ${spacing(3)};
        width: 100%;
        padding: ${spacing(3)};
        border-radius: 8px;
        border: 1px solid ${grey400};
        background-color: ${white100};
        font-family: ${font_family_weight_regular};
        ${font_md};
        color: ${text_colorTextPrimary};
        text-align: start;

        cursor: pointer;

        transition: background-color ${button_transitionSpeed} ease-out;

        &:hover {
          background-color: ${grey150};
        }

        &:active {
          background-color: ${grey300};
        }

        & .prompt-button-icon {
          flex-shrink: 0;
          display: flex;
        }
      }
    }
  }
`
